// extracted by mini-css-extract-plugin
export var lvh = "SmartBannerDetection-module__lvh___RUcrh";
export var svh = "SmartBannerDetection-module__svh___roI2r";